"use server";

import { serverLogin, serverLogout } from "@/lib/api/server";
import { ApiError } from "@/lib/api/response";
import type { LoginInput, LoginResult } from "./types";

export async function loginAction(input: LoginInput): Promise<LoginResult> {
  try {
    const user = await serverLogin(input);
    return { ok: true, user };
  } catch (err) {
    if (err instanceof ApiError) {
      return {
        ok: false,
        message: err.message,
        errors: err.validationErrors ?? undefined,
      };
    }
    throw err;
  }
}

export async function logoutAction(): Promise<void> {
  try {
    return await serverLogout();
  } catch (err) {
    if (err instanceof ApiError) return;
    throw err;
  }
}
